
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from "./store"

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@fortawesome/fontawesome-free/css/all.css'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronUp, faChevronDown, faPlayCircle, faAlignJustify, faAt, faUnlockAlt, faList, faSignOutAlt, faSignInAlt, faHome, faBookOpen, faFilePdf, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { faFacebook, faGoogle } from '@fortawesome/free-brands-svg-icons'
import VueI18n from 'vue-i18n'
import VueTheMask from 'vue-the-mask'
import './assets/css/style.scss'
import './registerServiceWorker'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-sugar.css'
import Vuelidate from 'vuelidate'
import GoogleAuth from 'signup_with_facebook_google_vue/src/config/google_oAuth.js'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'
import VueGtag from 'vue-gtag'
import VueSanitize from "vue-sanitize"
 
const gauthOption = {
  clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
  scope: 'profile email',
  prompt: 'select_account'
}


Vue.use(Vuetify)
Vue.use(GoogleAuth, gauthOption)

library.add(faChevronUp, faChevronDown, faPlayCircle, faAlignJustify, faFacebook, faGoogle, faAt, faUnlockAlt, faList, faSignOutAlt, faSignInAlt, faHome, faBookOpen, faFilePdf, faTrashAlt);

Vue.config.productionTip = false

Vue.use(VueGtag, {
  config: { id: 'UA-45577452-3' }
}, router)

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueI18n)
Vue.use(VueLoading, {
  color: '#3B94F1',
  isFullPage: true,
  loader: 'dots',
  backgroundColor: '#ffffff',
  width: 128,
  height: 128,
  opacity: 0.5,
  zIndex: 9999
})
Vue.use(VueToast, {
  position: 'top-right'
})
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(Vuelidate)
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead)
Vue.use(VueTheMask)
Vue.use(VueSanitize)

const i18n = new VueI18n({
  locale: 'pt',
  fallbackLocale: 'pt',
})
Sentry.setTag('projeto', 'agenda')
Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_DSN,
  environment: process.env.VUE_APP_ENV,
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ['localhost', 'jaleko.com.br/agenda', 'novo.jaleko.com.br/agenda', /^\//]
    })
  ],
  tracesSampleRate: 0.01
})

new Vue({
  i18n,
  router,
  store,
  vuetify: new Vuetify(),
  render: h => h(App),
}).$mount('#app')
